import Vue from 'vue';
import Vuex from 'vuex';
import Store from '@/vuex/store';
import VueLocalStorage from 'vue-localstorage';
import { liveflightStore } from '@/vuex/liveflight-store';

Vue.use(Vuex);
Vue.use(VueLocalStorage);

// default empty state
let state = {
  loading: true,
  token: '',
  booking_data: {},
  guests: {},
  availability: 0,
  discount_codes: [],
};

// state from browser local storage
let localstorage_state = JSON.parse(Vue.localStorage.get(process.env.VUE_APP_STORE_KEY));
if (localstorage_state) {
  Object.keys(localstorage_state).forEach((e) => {
    if (localstorage_state[e] && localstorage_state[e] != null) state[e] = localstorage_state[e];
  });
}

export default new Vuex.Store({
  state: state,
  getters: {
    loading(state) {
      return state.loading;
    },
    token(state) {
      return state.token;
    },
    booking_data(state) {
      return state.booking_data;
    },
    guests(state) {
      return state.guests;
    },
    availability(state) {
      return state.availability;
    },
    discount_codes(state) {
      return state.discount_codes;
    },
  },
  // mutations -> operazioni SINCRONE (triggerate da .commit())
  mutations: {
    loading(state, payload) {
      state.loading = payload;
    },
    token(state, payload) {
      state.token = payload;
    },
    booking_data(state, payload) {
      state.booking_data = payload;
    },
    guests(state, payload) {
      state.guests = payload;
    },
    availability(state, payload) {
      state.availability = payload;
    },
    discount_codes(state, payload) {
      state.discount_codes = payload;
    },
  },
  // actions -> operazioni ASINCRONE che lanciano mutations (triggerate da .dispatch())
  actions: {
    // toggle(context, payload) {
    //     context.commit('toggle', payload);
    // }
  },
  modules: {
    liveflight: liveflightStore,
  },
});

// salvataggio di elementi specifici in local storage
Store.subscribe((mutation, state) => {
  // qui va dichiarata la struttura dati che verrà salvata in local storage
  let localstorage_state = {
    token: Store.state.token,
    guests: Store.state.guests,
    liveflight: {
      adults: Store.state.liveflight.adults,
      children: Store.state.liveflight.children,
      travelers: Store.state.liveflight.travelers,
      departure_date: Store.state.liveflight.departure_date,
      arrival_date: Store.state.liveflight.arrival_date,
      departure_airport: Store.state.liveflight.departure_airport,
      departure_airport_label: Store.state.liveflight.departure_airport_label,
      arrival_airport: Store.state.liveflight.arrival_airport,
      arrival_airport_label: Store.state.liveflight.arrival_airport_label,
      flight_offer: Store.state.liveflight.flight_offer,
      results: Store.state.liveflight.results,
      return_flight: Store.state.liveflight.return_flight,
      //bags: Store.state.liveflight.bags,
      //added_bag_index: Store.state.liveflight.added_bag_index,
    },
  };

  if (mutation.type == 'token') {
    localstorage_state.token = state.token;
  }

  if (mutation.type == 'guests') {
    localstorage_state.guests = state.guests;
  }

  if (mutation.type == 'adults') {
    localstorage_state.liveflight.adults = state.liveflight.adults;
  }

  if (mutation.type == 'children') {
    localstorage_state.liveflight.children = state.liveflight.children;
  }

  if (mutation.type == 'travelers') {
    localstorage_state.liveflight.travelers = state.liveflight.travelers;
  }

  if (mutation.type == 'departure_date') {
    localstorage_state.liveflight.departure_date = state.liveflight.departure_date;
  }

  if (mutation.type == 'return_date') {
    localstorage_state.liveflight.return_date = state.liveflight.return_date;
  }

  if (mutation.type == 'departure_airport') {
    localstorage_state.liveflight.departure_airport = state.liveflight.departure_airport;
  }

  if (mutation.type == 'departure_airport_label') {
    localstorage_state.liveflight.departure_airport_label =
      state.liveflight.departure_airport_label;
  }

  if (mutation.type == 'return_airport') {
    localstorage_state.liveflight.return_airport = state.liveflight.return_airport;
  }

  if (mutation.type == 'return_airport_label') {
    localstorage_state.liveflight.return_airport_label = state.liveflight.return_airport_label;
  }

  if (mutation.type == 'results') {
    localstorage_state.liveflight.results = state.liveflight.results;
  }

  if (mutation.type == 'return_flight') {
    localstorage_state.liveflight.return_flight = state.liveflight.return_flight;
  }

  if (mutation.type == 'flight_offer') {
    localstorage_state.liveflight.flight_offer = state.liveflight.flight_offer;
  }

  if (mutation.type == 'bags') {
    localstorage_state.liveflight.bags = state.liveflight.bags;
  }

  if (mutation.type == 'flexible_bags') {
    localstorage_state.liveflight.flexible_bags = state.liveflight.flexible_bags;
  }

  Vue.localStorage.set(process.env.VUE_APP_STORE_KEY, JSON.stringify(localstorage_state));
});
